query competitionsBySport($sportId: UUID!, $search: String) {
  allCompetitions(
    condition: { sportId: $sportId, limbo: false }
    orderBy: COMPETITION_NAME_ASC
    filter: { competitionName: { includesInsensitive: $search } }
    first: 50
  ) {
    nodes {
      sportId
      competitionId
      competitionName
    }
  }
}
